module.exports = __webpack_public_path__ + "static/media/kevin.3c1c87e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kevin.jpg
// module id = 377
// module chunks = 16